import { ProfileClient } from 'entio-sdk';
import { FashProfile } from './dataTypes/fashProfile';
const { REACT_APP_API_PROFILE_URL } = process.env;

export const getProfileClient = () => {
    return new ProfileClient<FashProfile>({ appId: 'fashadmin', baseUrl: REACT_APP_API_PROFILE_URL });
};
